import { useEffect, useState } from 'react'

interface UseScrollHelperResponse<T extends { id: number }> {
  dataList: T[]
  onNextPageHandler: () => void
  isNextPage: boolean
  isLoading: boolean
}

export const useScrollHelper = <T extends { id: number }, Params>(
  getterData: (params: any, extraParams?: any) => any,
  params?: Params,
  skip = false,
  search?: string,
): UseScrollHelperResponse<T> => {
  const [offset, setOffset] = useState(0)
  const [loadMore, setLoadMore] = useState(true)
  const [dataList, setDataList] = useState<T[]>([])
  const { data, isLoading, isFetching } = getterData(
    { ...params, limit: 20, offset },
    { skip, refetchOnMountOrArgChange: true },
  )

  useEffect(() => {
    if (data && !data?.previous && loadMore) {
      setDataList(data.results)
      setLoadMore(false)
    } else if (data && !!data?.previous && loadMore) {
      setDataList((prev) => [...prev, ...data.results])
      setLoadMore(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (!skip) {
      const timeoutId = setTimeout(() => {
        setOffset(0)
        setLoadMore(true)
      }, 500)
      return () => clearTimeout(timeoutId)
    }
  }, [search, skip])

  const onNextPageHandler = () => {
    setOffset((prev) => prev + 20)
    setLoadMore(true)
  }

  return {
    dataList,
    onNextPageHandler,
    isNextPage: !!data?.next,
    isLoading: isFetching || isLoading,
  }
}
